export const urls = {
	private: `products?business_practices=private-label`,
	cleanLabel: `products?certification=certified-vegan&ingredients=clean-label`,
	nexty: `products?nexty_finalists=true`,
	newtoMarket: `products?new_to_market=true`,
	lgbtqOwned: `products?business_practices=LGBTQ%2B+Owned`,
	kehe: `products?distributor=8`,
	seeAll: 'products',
	productsExpo: 'products?attributes=event'
};

export const content = {
	newTopiaTitle: 'Discover These Trending Product Categories at Newtopia Now',
	expowTitle: 'Discover These Trending Product Categories at Expo West'
};
